import { defineStore } from 'pinia'

/**
 * Cache des libellés affichés dans le fil d'Ariane.
 * Clés : dirLib, dirLib~domLib, dirLib~domLib~ageLib, dirLib~domLib~ageLib~equLib.
 */
export type BreadcrumbHoverPreview = { label: string } | null

export const useBreadcrumbLabelsStore = defineStore('breadcrumbLabels', {
  state: () => ({
    directionLabels: new Map<string, string>(),
    domaineLabels: new Map<string, string>(),
    agenceLabels: new Map<string, string>(),
    equipeLabels: new Map<string, string>(),
    /** Aperçu du domaine au survol d’une colonne (page direction) */
    hoverPreviewDomaine: null as BreadcrumbHoverPreview,
  }),

  getters: {
    getDirectionLabel: (s) => (id: string) =>
      s.directionLabels.get(id) ?? undefined,
    getDomaineLabel: (s) => (id: string) =>
      s.domaineLabels.get(id) ?? undefined,
    getAgenceLabel: (s) => (id: string) =>
      s.agenceLabels.get(id) ?? undefined,
    getEquipeLabel: (s) => (id: string) =>
      s.equipeLabels.get(id) ?? undefined,
  },

  actions: {
    setHoverPreviewDomaine(preview: BreadcrumbHoverPreview) {
      this.hoverPreviewDomaine = preview
    },
    setDirectionLabel(id: string, label: string) {
      if (label) this.directionLabels.set(id, label)
    },
    setDomaineLabel(id: string, label: string) {
      if (label) this.domaineLabels.set(id, label)
    },
    setAgenceLabel(id: string, label: string) {
      if (label) this.agenceLabels.set(id, label)
    },
    setEquipeLabel(id: string, label: string) {
      if (label) this.equipeLabels.set(id, label)
    },
  },
})
